import sitelinks from './sitelinks'
import sitedata from './sitedata'
import sbApiRequests from './sbApiRequests'

const config = {
  ...sitelinks,
  ...sitedata,
  ...sbApiRequests,
  homepage: {
    platformConfig: {
      ios: {
        order: 1,
        store: 'Apple',
        filter: 'iOS',
      },
      android: {
        order: 2,
        store: 'Play',
        filter: 'Android',
      },
      pc: {
        order: 3,
        store: 'Microsoft',
        filter: 'PC',
      },
    },
  },
}

export default config
